import { Link } from "react-router-dom";

import { SwiftLogo } from "@/components/brand/swift-logo";
import { LEGAL_LINKS } from "@/lib/legal";
import { getSupportEmail } from "@/lib/support";

// Marketing footer. Used by the marketing layout AND can be dropped into
// any custom layout. Includes legal links + a support mailto - required
// by the pre-launch checklist as the global "where do I email you?"
// surface.
//
// Theme-aware: background, borders, text all flip with .dark.

export function Footer() {
  const supportEmail = getSupportEmail();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-10 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2">
          <SwiftLogo className="h-6 w-auto dark:invert" />
          <p className="text-[12px] text-muted-foreground">
            Ship your MVP in 24–72 hours.
          </p>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[12.5px] text-muted-foreground">
          {LEGAL_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="transition-colors hover:text-foreground hover:underline hover:underline-offset-[3px]"
            >
              {link.label}
            </Link>
          ))}
          <a
            href={`mailto:${supportEmail}`}
            className="transition-colors hover:text-foreground hover:underline hover:underline-offset-[3px]"
          >
            {supportEmail}
          </a>
        </nav>
      </div>
      <div className="border-t border-border bg-muted">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
          <p className="text-[11px] text-muted-foreground">
            © {year} Swift MVP. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
